import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const StaffLogin = () => {
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    // Simulate login logic - route to portal
    navigate('/staff-portal');
  };

  return (
    <div 
      className="login-page" 
      style={{ 
        background: 'linear-gradient(to right, rgba(23, 44, 79, 0.95), rgba(42, 46, 52, 0.9)), url("https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=1920&auto=format&fit=crop") center/cover no-repeat',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        /* Default 150px top padding to perfectly clear the fixed global header */
        padding: '150px 1.5rem 4rem 1.5rem' 
      }}
    >
      {/* MOBILE RESPONSIVE FIXES SPECIFIC TO LOGIN PAGE */}
      <style>
        {`
          @media (max-width: 768px) {
            .login-page {
              padding-top: 160px !important; /* Increased to ensure clearance of stacked mobile header */
              align-items: flex-start !important; /* Prevents tall content from pushing up behind the header */
            }
            .login-brand-context {
              margin-bottom: 1.5rem !important;
            }
            .login-brand-context a {
              font-size: 1.4rem !important;
            }
            .login-card {
              box-shadow: 0 10px 30px rgba(0,0,0,0.4) !important;
            }
            .login-header {
              padding: 2rem 1.5rem 1rem 1.5rem !important;
            }
            .login-header h2 {
              font-size: 1.25rem !important;
            }
            .login-header p {
              font-size: 0.85rem !important;
            }
            .login-form {
              padding: 1.5rem !important;
            }
            .login-warning {
              padding: 1.25rem 1.5rem !important;
            }
          }
        `}
      </style>

      <div className="container login-container" style={{ maxWidth: '450px', width: '100%', padding: 0 }}>
        
        {/* Brand Context */}
        <div className="text-center login-brand-context" style={{ marginBottom: '2.5rem' }}>
          <Link to="/" style={{ fontSize: '1.8rem', fontWeight: '800', letterSpacing: '2px', color: 'var(--color-white)', textDecoration: 'none' }}>
          </Link>
        </div>

        {/* Login Card */}
        <div className="login-card" style={{ backgroundColor: 'var(--color-white)', borderRadius: '16px', boxShadow: '0 25px 50px rgba(0,0,0,0.3)', overflow: 'hidden' }}>
          
          <div className="login-header text-center" style={{ padding: '3rem 2rem 1.5rem 2rem', borderBottom: '1px solid rgba(0,0,0,0.05)' }}>
            <h2 className="text-primary-navy" style={{ color: 'var(--color-primary-navy)', fontSize: '1.5rem', marginBottom: '0.5rem' }}>Operative Login</h2>
            <p style={{ margin: 0, fontSize: '0.95rem', color: 'var(--color-secondary-grey)' }}>
              Enter your credentials to access the portal.
            </p>
          </div>

          <form className="login-form page-contact-form" onSubmit={handleLogin} style={{ padding: '2.5rem 2rem' }}>
            
            <div className="form-group" style={{ marginBottom: '1.5rem' }}>
              <label htmlFor="employeeId" style={{ fontWeight: '600', color: 'var(--color-primary-dark)', display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Employee ID or Email</label>
              <input 
                type="text" 
                id="employeeId" 
                placeholder="NMK-10294" 
                required 
                style={{ width: '100%', padding: '1rem 1.25rem', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '8px', outline: 'none', fontSize: '1rem' }}
              />
            </div>

            <div className="form-group" style={{ marginBottom: '1.5rem' }}>
              <label htmlFor="password" style={{ fontWeight: '600', color: 'var(--color-primary-dark)', display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Password</label>
              <input 
                type="password" 
                id="password" 
                placeholder="••••••••" 
                required 
                style={{ width: '100%', padding: '1rem 1.25rem', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '8px', outline: 'none', fontSize: '1rem' }}
              />
            </div>

            <div className="login-actions" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2.5rem', fontSize: '0.9rem' }}>
              <label className="remember-me" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--color-secondary-grey)', cursor: 'pointer' }}>
                <input type="checkbox" style={{ cursor: 'pointer' }} />
                <span>Remember Device</span>
              </label>
              <Link to="#" className="forgot-password-link" style={{ color: 'var(--color-primary-navy)', fontWeight: '600', textDecoration: 'none' }}>Recovery</Link>
            </div>

            <button type="submit" className="btn btn-primary w-100" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', border: 'none', cursor: 'pointer', width: '100%', padding: '1.1rem', fontSize: '1rem', borderRadius: '8px', fontWeight: '700', letterSpacing: '0.5px' }}>
              Secure Authorization
            </button>
          </form>

          {/* Official Warning Notice */}
          <div className="login-warning" style={{ backgroundColor: '#f8f9fa', padding: '1.5rem 2rem', borderTop: '1px solid rgba(0,0,0,0.05)', fontSize: '0.85rem', color: 'var(--color-secondary-grey)', lineHeight: '1.5' }}>
            <strong style={{ color: 'var(--color-primary-dark)', display: 'block', marginBottom: '0.5rem', letterSpacing: '1px', fontSize: '0.75rem', textTransform: 'uppercase' }}>Restricted System</strong>
            This network is for authorized Nightmark Protective Services personnel only. All activity is monitored and logged. Unauthorized access is strictly prohibited and violates UK law.
          </div>
        </div>

        {/* Footer Link */}
        <div className="login-footer text-center" style={{ marginTop: '2.5rem' }}>
          <Link to="/" style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)', fontWeight: '600', textDecoration: 'none', transition: 'color 0.3s ease' }} onMouseOver={e => e.target.style.color = 'var(--color-white)'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>
            ← Return to Public Website
          </Link>
        </div>

      </div>
    </div>
  );
};

export default StaffLogin;